import ApiService from './ApiService'

export const getApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data?.company) {
            datas.company_id = data?.company
        }
        if (data?.customer) {
            datas.customer_id = data?.customer
        }
        if (data.selectedTab) {
            datas.processed_to_wms = data.selectedTab
        }
        if (data.orderType) {
            datas.asn_type = data.orderType
        }
    }
    return ApiService.get('/api/v1/ensemble/asn-hdr/', datas)
}
export const createApiRecord = data => ApiService.filePost('/api/v1/ensemble/asn-hdr/', data)
export const getApiRecord = id => ApiService.get(`/api/v1/ensemble/asn-hdr/${id}/`)
export const updateApiRecord = (id, data) => ApiService.put(`/api/v1/ensemble/asn-hdr/${id}/`, data)
export const deleteApiRecord = id => ApiService.delete(`/api/v1/ensemble/asn-hdr/${id}/`)

export const createApiOrderRecord = data => ApiService.post('/api/v1/ensemble/asn-dtl/', data)
export const getApiOrderRecord = data => ApiService.get(`/api/v1/ensemble/asn-dtl/`, data)
export const updateApiOrderRecord = (id, data) => ApiService.put(`/api/v1/ensemble/asn-dtl/${id}/`, data)
export const deleteApiOrderRecord = id => ApiService.delete(`/api/v1/ensemble/asn-dtl/${id}/`)

export const uploadApiOrderRecords = data => ApiService.filePost('/api/v1/meson-app/upload-asn/', data)
export const uploadPOApiOrderRecords = data => ApiService.filePost('/api/v1/meson-app/upload-purchase-order/', data)
export const uploadApiExtraDocuments = (id, data) => ApiService.filePost(`/api/v1/ensemble/asn-hdr/${id}/upload_file/`, data)

export const getApiAsnTypeData = data => ApiService.get('/api/v1/ensemble/asn-hdr/get_asn_type_list/', data)
